export default ({ html }) =>
  html`
    <path
      d="M19.62,10.37 L9.62,0.37 C9.37,0.12 9.12,0 8.75,0 L1.25,0 C0.5,0 0,0.5 0,1.25 L0,8.75 C0,9.12 0.12,9.37 0.37,9.62 L10.37,19.62 C10.62,19.87 10.87,20 11.25,20 C11.62,20 11.87,19.87 12.12,19.62 L19.62,12.12 C20.12,11.62 20.12,10.87 19.62,10.37 Z M5,6.25 C4.25,6.25 3.75,5.75 3.75,5 C3.75,4.25 4.25,3.75 5,3.75 C5.75,3.75 6.25,4.25 6.25,5 C6.25,5.75 5.75,6.25 5,6.25 Z"
    />
  `
